/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EventManagementListEventRequest = {
    perPage?: number | null;
    page?: number | null;
    keyword?: string | null;
    sort?: string | null;
    direction?: EventManagementListEventRequest.direction | null;
    title?: string | null;
    status?: string | null;
};

export namespace EventManagementListEventRequest {

    export enum direction {
        ASC = 'asc',
        DESC = 'desc',
    }


}

